import { Injectable } from '@angular/core';
import { ReportInventoryStocktakingExportQuery, ReportInventoryStocktakingExportQueryHandlerBase } from '@skylab-shared/business';

import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(ReportInventoryStocktakingExportQuery)
@Wrapper(ReportInventoryStocktakingExportQueryHandlerBase)
export class ReportInventoryStocktakingExportQueryHandler {
    public constructor(
        http: Http
    ) { }
}
